import React from 'react';
import { ITranslateProps, translate } from '../../mixins/translate';
import { fetchDelete, fetchGet } from '../../store/fetch';
import { IconRemoveButton } from '../common/iconButtons/IconRemoveButton';
import { Table, TableBody, TableButtons, TableData, TableHead, TableHeader, TableHeadRow, TableRow } from '../elements';
import { ComponentSetStatePromised } from '../utils/ComponentSetStatePromised';
import { NullableBoolean } from '../utils/NullableBoolean';

interface IRelationsListProps extends ITranslateProps {
    id?: string;
}

interface IRelation {
    id: string;
    name: string;
    role: string;
    isClient: boolean;
}

interface IRealtionsListState {
    items: IRelation[];
}

class RelationsList extends ComponentSetStatePromised<IRelationsListProps, IRealtionsListState> {
    constructor(props: IRelationsListProps) {
        super(props);

        this.state = {
            items: [],
        };
    }

    public override componentDidMount() {
        void this.load(this.props.id!);
    }

    public override render() {
        return (
            <Table spaced>
                <TableHead>
                    <TableHeadRow light={true}>
                        <TableHeader className="">{this.props.t('company.companyName')}</TableHeader>
                        <TableHeader className="">{this.props.t('company.companyRole')}</TableHeader>
                        <TableHeader className="">{this.props.t('company.isClient')}</TableHeader>
                        <TableHeader className="text-right">&nbsp; </TableHeader>
                    </TableHeadRow>
                </TableHead>
                <TableBody>
                    {this.state.items.map((item, i) => (
                        <TableRow key={i}>
                            <TableData>{item.name}</TableData>
                            <TableData>{item.role}</TableData>
                            <TableData>
                                <NullableBoolean value={item.isClient} />
                            </TableData>
                            <TableButtons>
                                <IconRemoveButton
                                    removeQuestion={this.props.t('common.confirmDelete', item.name)}
                                    onClick={async () => this.remove(item.id)}
                                />
                            </TableButtons>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        );
    }

    private async load(companyId: string) {
        const url = `/api/companyRelations?companyId=${companyId}`;
        const result = await fetchGet(url);
        await this.setStatePromised({ items: result.json.items });
    }

    private async remove(id: string) {
        const url = `/api/companyRelations/${this.props.id}?relationId=${id}`;
        await fetchDelete(url);
        await this.load(this.props.id!);
    }
}

// eslint-disable-next-line import/no-default-export
export default translate()(RelationsList);
